export function GetStatus(token) {
	return fetch("https://#{CustomDomain}#/api/license/status", {
		headers: {
			"osc-authorization": `Bearer ${token}`,
		},
	}).then((x) => x.json());
}